import { Component, inject, signal, computed, input, output, effect } from '@angular/core';
import { INanoprecisePlantAssetDetailList } from '../../models/sensor.model';
import { AssetsService } from '../../services/asset.service';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { LP_UI_CONFIG } from '../../core/tokens';
import { SelectComponent } from '../select/selectComponent';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-match-equipment',
  templateUrl: './match-equipment.html',
  styleUrls: ['./match-equipment.scss'],
  imports: [SelectComponent, NzIconModule],
})
export class MatchEquipmentComponent {
  public cfg = inject(LP_UI_CONFIG);
  public i18n = inject(I18nService);
  private ui = inject(UiService);
  private assetsService = inject(AssetsService);
  wizardsteps = input<string[]>([]);
  currentstep = input<number>();
  counter = input<number>();
  assetId = input.required<number>();
  navBack = output<void>();
  navExit = output<void>();
  navContinue = output<void>();
  navHeader = output<number>();
  nanoprecisePlantAssetDetailList = signal<any[]>([]);
  np1 = signal<any[]>([]);
  npEquipmentDetatil = signal<INanoprecisePlantAssetDetailList | null>(null);
  plantList = signal<string[]>([]);
  equipmentList = signal<string[]>([]);
  plantListselected = signal<boolean>(true);
  selectedNPEquipment = signal<string>('');
  matchConnect = signal<boolean>(false);
  hasResponse = signal<boolean>(false);
  private isLoading = signal<boolean>(false);

  isMobile = this.ui.IsMobile;
  isTablet = computed(() => this.ui.IsTablet);
  isDisabled = computed(() => !this.hasResponse());

  constructor() {
    effect(() => {
      const assetId = this.assetId();
      if (assetId) {
        this.loadNanoPreciseData(assetId);
      }
    });
  }

  private async loadNanoPreciseData(assetId: number) {
    this.isLoading.set(true);

    try {
      const result = await this.assetsService.getNanoPreciseAssetsDetail(assetId);
      let processedResult = result;

      if (this.cfg.splitio_fallback?.simulated_responses?.rotating_equipment?.length > 0) {
        processedResult = result.concat(
          this.cfg.splitio_fallback.simulated_responses?.rotating_equipment
        );
      }

      this.hasResponse.set(true);
      this.nanoprecisePlantAssetDetailList.set(processedResult);
      this.np1.set(processedResult);

      const uniquePlants = processedResult
        .map((plant) => plant['plantName'])
        .filter((value, index, current_value) => current_value.indexOf(value) === index);

      this.plantList.set(uniquePlants);
    } catch (error) {
      console.error('Error loading NanoPrecise data:', error);
      this.hasResponse.set(false);
    } finally {
      this.isLoading.set(false);
    }
  }

  onOptionsSelected(event: string) {
    this.matchConnect.set(true);
    this.selectedNPEquipment.set(event);

    const detail = this.np1().find((equipment) => equipment['equipmentName'] === event);
    this.npEquipmentDetatil.set(detail);
    this.assetsService.setRotatingEquipmentDetail(detail);
  }

  plantOptionsSelected(event: string) {
    this.selectedNPEquipment.set(this.i18n.langString('test_pump'));
    this.plantListselected.set(false);
    this.assetsService.setRotatingEquipmentDetail(null);

    const filteredEquip = this.nanoprecisePlantAssetDetailList()
      .filter((plant) => plant['plantName'] === event)
      .map((equipment) => equipment['equipmentName'])
      .filter((value, index, current_value) => current_value.indexOf(value) === index);

    this.equipmentList.set(filteredEquip);
  }
}
